const KEY = 'dss.group-invitation-return'
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

export function validInvitationSecret(value: string) { return UUID.test(value) }

/** Только секрет/срок на время OIDC перехода. Ни пароль, ни email сюда не попадают. */
export function rememberInvitation(secret: string, expiresAt: string, kind: 'group' | 'employee' | 'owner' = 'group') {
  if (!validInvitationSecret(secret)) throw new Error('Некорректная ссылка приглашения')
  const expires = Math.min(Date.parse(expiresAt), Date.now() + 72 * 3600_000)
  if (!Number.isFinite(expires) || expires <= Date.now()) throw new Error('Срок ссылки истёк')
  sessionStorage.setItem(KEY, JSON.stringify({ secret, expires, kind }))
}
export function invitationReturnPath(): string | null {
  try {
    const value: unknown = JSON.parse(sessionStorage.getItem(KEY) ?? 'null')
    if (typeof value === 'object' && value !== null && 'secret' in value && 'expires' in value
      && typeof value.secret === 'string' && validInvitationSecret(value.secret)
      && typeof value.expires === 'number' && value.expires > Date.now()
      && value.expires <= Date.now() + 72 * 3600_000) {
      if ('kind' in value && !['group', 'employee', 'owner'].includes(String(value.kind))) return null
      return `/${'kind' in value ? value.kind : 'group'}-invite#${value.secret}`
    }
  } catch { /* Отсутствие storage не должно открывать произвольный redirect. */ }
  forgetInvitation()
  return null
}
export function forgetInvitation() {
  try { sessionStorage.removeItem(KEY) } catch { /* Запрещённое storage уже ничего не сохраняет. */ }
}
